import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy, ArrowRight, MapPin, Truck } from "lucide-react";
import api from "../lib/api";
import { fileUrl, videoSrc, isYouTube, PlayBadge, VideoModal, ShareButtons } from "./DriverMedia";

export default function DriverSpotlight() {
  const [driver, setDriver] = useState(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    api.get("/drivers/current").then((r) => setDriver(r.data)).catch(() => {});
  }, []);

  if (!driver) return null;
  const src = videoSrc(driver);

  return (
    <section data-testid="home-driver-spotlight" className="py-16 md:py-24 border-t border-slate-900 bg-slate-950">
      {playing && <VideoModal driver={driver} onClose={() => setPlaying(false)} />}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-12 gap-10 items-center">
        <div
          data-testid="home-spotlight-media"
          className={`md:col-span-6 relative group ${src ? "cursor-pointer" : ""}`}
          onClick={() => src && setPlaying(true)}
        >
          <div className="absolute -inset-3 stripe-amber rounded-2xl opacity-30 blur-sm" />
          <div className="relative rounded-2xl border border-slate-700 overflow-hidden aspect-video bg-slate-900">
            {driver.photo_file_id ? (
              <img src={fileUrl(driver.photo_file_id)} alt={driver.name} className="w-full h-full object-cover" />
            ) : src && !isYouTube(src) ? (
              <video src={`${src}#t=0.5`} muted playsInline preload="metadata" className="w-full h-full object-cover" />
            ) : (
              <div className="w-full h-full flex items-center justify-center"><Truck className="w-20 h-20 text-slate-700" /></div>
            )}
            {src && <PlayBadge />}
          </div>
          <div className="absolute top-4 left-4 bg-amber-500 text-slate-950 text-xs font-bold uppercase tracking-widest px-3 py-1.5 rounded-full flex items-center gap-1.5"><Trophy className="w-3.5 h-3.5" /> Driver of the Week</div>
        </div>
        <div className="md:col-span-6">
          <div className="text-xs uppercase tracking-[0.25em] text-amber-400 font-semibold">Team Spotlight</div>
          <h2 data-testid="home-spotlight-name" className="mt-3 text-3xl md:text-4xl font-bold uppercase text-white display">{driver.name}</h2>
          <div className="mt-2 flex items-center gap-3 text-sm text-slate-400">
            <span>Week of {driver.week_of}</span>
            {driver.route_zone && <span className="flex items-center gap-1 text-amber-400"><MapPin className="w-4 h-4" /> {driver.route_zone}</span>}
          </div>
          <p className="mt-5 text-slate-300 leading-relaxed max-w-lg line-clamp-4">{driver.achievements}</p>
          <div className="mt-8 flex flex-col sm:flex-row sm:items-center gap-4">
            <Link to={`/driver-of-the-week/${driver.id}`} data-testid="home-spotlight-link" className="inline-flex items-center gap-2 rounded-full bg-amber-500 hover:bg-amber-600 text-slate-950 font-bold uppercase tracking-wide text-sm px-6 py-3 transition-colors w-fit">
              {src ? "Watch the story" : "Read the story"} <ArrowRight className="w-4 h-4" />
            </Link>
            <ShareButtons driver={driver} compact />
          </div>
        </div>
      </div>
    </section>
  );
}
